import React, { Component } from 'react';
import {Dropdown} from 'components/Dropdown/Dropdown';
import Multiselect from 'components/Multiselect';
import { NameInput } from 'components/Input';
class component extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isFetchingTest: false,
      dataTest: [
        {value: 1, label: 'test 1'},
        {value: 3, label: 'test 2'}
      ],

      data: [
        { label: 'Chocolate', value: '1' },
        { label: 'Vanilla', value: '2' },
        { label: 'Strawberry', value: '3' }
      ],

      selectList: [
        { value: 0, text: 'Awaiting Review' },
        { value: 1, text: 'Approved', selected: true },
        { value: 3, text: 'Closed' }
      ],
      valueMulti: [],
      isFetchingMulti: false
    };
  }

  onChangeStatus(event) {
    this.setState({
      valueTest: event.value
    });
  }

  fetchDataTest() {
    this.setState({
      isFetchingTest: true
    });

    setTimeout(() => {
      this.setState({
        isFetchingTest: false,
        dataTest: [
          {value: 1, label: 'test 1'},
          {value: 2, label: 'test 2'},
          {value: 3, label: 'test 3'},
          {value: 4, label: 'test 4'},
          {value: 1, label: 'test 1'},
          {value: 2, label: 'test 2'},
          {value: 3, label: 'test 3'},
          {value: 4, label: 'test 4'}
        ]
      });
    }, 500);
  }

  onSubmit(event) {
    event.preventDefault();
    const service = this.service.validate();
    const service1 = this.service1.validate();
    const multiSelect = this.multiSelect.validate();
    // const input1 = this.articleTitle.validate();

    if (!service) {
      return false;
    }

    if (!service1) {
      return false;
    }

    if (!multiSelect) {
      return false;
    }
    if (!articleTitle) {
      return false;
    }

    return true;
  }

  changeMultiValue(value) {
    this.setState({
      valueMulti: value
    });
  }

  fetchDataMulti() {
    this.setState({
      isFetchingMulti: true
    });

    setTimeout(() => {
      this.setState({
        isFetchingMulti: false,
        data: [
          { label: 'Chocolate', value: '1' },
          { label: 'Vanilla', value: '2' },
          { label: 'Strawberry', value: '3' },
          { label: 'Caramel', value: '4' },
          { label: 'Cookies and Cream', value: '5' },
          { label: 'Peppermint', value: '6' }
        ]
      });
    }, 500);
  }

  handleChangeValue = () => {
    //
  }

  render() {
    const styles = {
      padding: '20px'
    };

    return (
      <div style={styles}>
        <h3>Dropdown with filter</h3>
        { /* autoWidth={false}: custom width
          onRemote (function): request to server when open dropdown
        */}

        <Dropdown
          filter={true}
          onChange={ref => {this.onChangeStatus(ref);}}
          className='filestring-dropdown filter-dropdown'
          value={this.state.valueTest}
          options={this.state.dataTest} style={{width: '250px'}}
          loading={this.state.isFetchingTest}
          onRemote={this.fetchDataTest.bind(this)}
          filterPlaceholder='Filter'
          placeholder='chooose services'
          errorMessage='This information is required.'
          ref={ref => {
            this.service = ref;
          }}
        />

        <h3>Dropdown</h3>
        <Dropdown
          onChange={ref => {this.onChangeStatus(ref);}}
          className='filestring-dropdown filter-dropdown'
          value={this.state.valueTest}
          options={this.state.dataTest}
          placeholder='chooose services'
          errorMessage='This information is required.'
          autoWidth={false}
          ref={ref => {
            this.service1 = ref;
          }}
        />

        <h3>Multiselect</h3>

        <Multiselect
          placeholder='please choose'
          items={this.state.data}
          value={this.state.valueMulti}
          onChange={this.changeMultiValue.bind(this)}
          onRemote={this.fetchDataMulti.bind(this)}
          isLoading={this.state.isFetchingMulti}
          errorMessage='This information is required.'
          ref={ref => {
            this.multiSelect = ref;
          }}
        />

        <h3>Text field</h3>
        <NameInput
          label='Title'
          type='text'
          maxLength='240'
          autoFocus
          onChange={this.handleChangeValue}
          defaultValue='2323'
          errorMessage='This information is required.'
          ref={ref => {
            this.articleTitle = ref;
          }}
        />

        <button onClick={this.onSubmit.bind(this)}>submit</button>
      </div>
    );
  }
}
// const mapStateToProps = (state, ownProps) => {
//   return state.UserStore;
// };

export default component;



// WEBPACK FOOTER //
// ./src/ExampleComponent/ExampleComponent.js